/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".candidacy-overview[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center}.candidacy-overview[_ngcontent-%COMP%]   .candidacy[_ngcontent-%COMP%]{margin:0 15px 15px;width:calc(100vw - 2 * 15px);max-width:700px}"];
export { styles as styles };
